<template>
  <div class="filter-container">
    <i class="mdi" :class="getFilterClass" @click="toggleFiltersDropdown()"></i>
    <div v-if="toggled" v-on-clickaway="toggleFiltersDropdown" class="filter-dropdown">
      <date-picker-component
        v-if="filter.type === TableFilter.FILTER_TYPE_DATE_RANGE"
        :config="getDateRangeConfig()"
        :selectedDates="getDateRangeSelected()"
        @onDateSelected="onDateRangeSelected"
        @onDateCleared="onDateRangeCleared">
      </date-picker-component>
      <table-filter-list-component
        v-else
        :uid="uid"
        :filters="filter.items || []"
        :selected="selectedFilters"
        @setSelectedFilters="setSelectedFilters">
      </table-filter-list-component>
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'
  import TableFilterListComponent from '@/components/layout/table/TableFilterListComponent'
  import DatePickerComponent from '@/components/layout/utility/DatePickerComponent'
  import TableFilter from '@/classes/case/TableFilter'
  import moment from 'moment'

  export default {
    name: 'table-filter-component',
    mixins: [clickaway],
    components: {
      TableFilterListComponent,
      DatePickerComponent
    },
    data () {
      return {
        toggled: false,
        TableFilter: TableFilter,
        moment: moment
      }
    },
    props: {
      uid: {
        type: String,
        default: ''
      },
      filter: {
        type: Object,
        required: true
      },
      selected: {
        type: Object,
        default: () => {}
      },
      default_toggle: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      getFilterClass () {
        return {
          ' mdi-filter': this.hasSelectedFilters,
          ' mdi-filter-outline': !this.hasSelectedFilters
        }
      },
      selectedFilters () {
        return this.selected[this.uid] || []
      },
      customSelectedFilters () {
        return this.getDateRangeSelected()
      },
      hasSelectedFilters () {
        return this.selectedFilters.length || this.customSelectedFilters.length
      }
    },
    methods: {
      getDateRangeConfig () {
        return {
          dateFormat: 'Y-m-d',
          static: false,
          mode: 'range',
          inline: true
        }
      },
      getDateRangeSelected () {
        let dateStart = this.selected[this.filter.limit_start]
        let dateEnd = this.selected[this.filter.limit_end]
        return dateStart && dateEnd ? [dateStart, dateEnd] : []
      },
      toggleFiltersDropdown () {
        this.toggled = !this.toggled
        this.$emit('setDefaultToggle', this.toggled)
      },
      setSelectedFilters (selectedValues) {
        this.selected[this.uid] = selectedValues
        this.$emit('setSelectedFilters', this.selected)
      },
      onDateRangeSelected (selectedDates) {
        if (selectedDates.length === 2) {
          this.selected[this.filter.limit_start] = moment(selectedDates[0]).format('YYYY-MM-DD')
          this.selected[this.filter.limit_end] = moment(selectedDates[1]).format('YYYY-MM-DD')
          this.$emit('setSelectedFilters', this.selected)
        }
      },
      onDateRangeCleared () {
        this.selected[this.filter.limit_start] = null
        this.selected[this.filter.limit_end] = null
        this.$emit('setSelectedFilters', this.selected)
      }
    },
    created () {
      this.toggled = this.default_toggle
    }
  }
</script>
<style lang="sass" scoped>
  .filter-container
    position: relative
  .filter-dropdown
    background: white
    box-shadow: 0 10px 20px rgba(0, 0, 0, .3)
    padding: 1rem
    top: 2rem
    position: absolute
    z-index: 99
</style>
